<div class="map-container">
  <app-side-bar (changeFilter)="updateFilter($event)" (changeMap)="updateMapLayer($event)" [map]="map"
    [mapChangeEvent$]="layersSubject.asObservable()" [siteLayers]="siteLayers"></app-side-bar>
  <div class="map-frame">
    <div id="map"></div>
  </div>
  <app-time-bar id="sidebar" (updateData)="updateMap($event)" [map]="map"></app-time-bar>
</div>